import { Link } from "react-router-dom";
import { Wrench, Building2 } from "lucide-react";

export default function GrowWith() {
  return (
    <section className="py-20 px-6 max-w-5xl mx-auto" data-testid="grow-with">
      <div className="text-center mb-12">
        <h2 className="font-display text-3xl sm:text-4xl uppercase tracking-tight text-white">Grow With DuroTech28</h2>
        <p className="text-sm text-zinc-400 mt-3">Great Technology Starts With Great Partnerships.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-6">
        <div className="rounded-2xl p-8 bg-[#121216] gold-border flex flex-col" data-testid="grow-technicians">
          <Wrench className="w-7 h-7 text-[#d4af37] mb-4" strokeWidth={1.5} />
          <h3 className="font-display text-xl uppercase text-white mb-2">For Technicians</h3>
          <p className="text-xs text-zinc-400 leading-relaxed flex-1">
            Join our growing network of skilled technology professionals.
          </p>
          <Link to="/careers-partners#technician" data-testid="grow-apply-btn"
            className="mt-6 block text-center py-3 rounded bg-gradient-to-r from-[#d4af37] to-[#e6ca65] text-black font-bold uppercase tracking-wider text-xs hover:opacity-95 transition-opacity">
            Apply as a Technician
          </Link>
        </div>
        <div className="rounded-2xl p-8 bg-[#121216] gold-border flex flex-col" data-testid="grow-businesses">
          <Building2 className="w-7 h-7 text-[#d4af37] mb-4" strokeWidth={1.5} />
          <h3 className="font-display text-xl uppercase text-white mb-2">For Businesses</h3>
          <p className="text-xs text-zinc-400 leading-relaxed flex-1">
            Partner with DuroTech28 for professional technology installation and infrastructure services.
          </p>
          <Link to="/careers-partners#partner" data-testid="grow-partner-btn"
            className="mt-6 block text-center py-3 rounded border border-[#d4af37]/40 text-[#d4af37] font-bold uppercase tracking-wider text-xs hover:bg-[#d4af37] hover:text-black transition-colors">
            Become a Partner
          </Link>
        </div>
      </div>
    </section>
  );
}
